import { render } from "./NumberChange.vue?vue&type=template&id=821458de&scoped=true&ts=true"
import script from "./NumberChange.vue?vue&type=script&lang=ts"
export * from "./NumberChange.vue?vue&type=script&lang=ts"

import "./NumberChange.vue?vue&type=style&index=0&id=821458de&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-821458de"]])

export default __exports__